import { CircleAlert } from "lucide-react";

import { isForbidden } from "@/api/errors";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

export function ErrorState({
  error,
  onRetry,
  compact = false,
}: {
  error: unknown;
  onRetry?: () => void;
  compact?: boolean;
}) {
  const message = isForbidden(error)
    ? "You don't have permission for this data."
    : error instanceof Error
      ? error.message
      : "Something went wrong.";

  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center gap-2 text-center",
        compact ? "py-8" : "py-16",
      )}
    >
      <CircleAlert className="text-destructive size-5" />
      <p className="text-muted-foreground text-sm">{message}</p>
      {onRetry && !isForbidden(error) && (
        <Button variant="outline" size="sm" onClick={onRetry}>
          Retry
        </Button>
      )}
    </div>
  );
}
